<template>
  <div class="home">
    <Welcome />
    <!-- <HelloWorld /> -->
  </div>
</template>

<script>
import Welcome from '../components/Welcome.vue';
export default {
  name: "Home",
  components: {Welcome}
};
</script>
